import Responsive from './Responsive';

module.exports = function() {
	const r = new Responsive();
	const movieRatio = 16/9;//比率
	const adjustBaseElement = $('header.page_header,.home_mv-mv');//基準とする親領域
	const videoID = adjustBaseElement.data('youtubeid');//動画ID
	let ytPlayer = {};//動画格納用オブジェクト
	let ytPlayer2 = {};//SP動画格納オブジェクト

	let tag = document.createElement('script');

	tag.src = "https://www.youtube.com/iframe_api";
	let firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

	/**
	 * 動画のサイズを親領域に合わせて調整する
	 * @param  $parent 基準とする親領域
	 */
	const movieAdjust = ($parent)=>{
		let _thisparent = $parent;
		let adjustWidth = $parent.width();
		let adjustHeight = $parent.height()*1.2;
		if (adjustHeight > adjustWidth / movieRatio) {
			adjustWidth = adjustHeight * movieRatio;
		}
		$parent.find('iframe').css({width:(adjustWidth),height:(adjustWidth/movieRatio)});
		$(window).on('resize',function(){
			movieAdjust(_thisparent);
		});
	}
	/**
	 * PC版動画プレイヤー準備完了時の処理
	 * @param  {object} event youtube event object
	 */
	const onPlayerReady = (event) =>{
		movieAdjust(adjustBaseElement);
		event.target.playVideo(adjustBaseElement);
		event.target.mute();
	}
	/**
	 * SP版動画プレイヤー準備完了時の処理
	 * @param  {object} event youtube event object
	 */
	const onPlayerReadySP = (event) =>{
		movieAdjust(adjustBaseElement);
		adjustBaseElement.on('click',function(){
			event.target.playVideo();
		})
	}
	/**
	 * PC版動画プレイヤー終了時にloop
	 * @param  {object} event youtube event object
	 */
	const onPlayerStateChange = (e) =>{
		var ytStatus = e.target.getPlayerState();
		if (ytStatus == YT.PlayerState.ENDED) {
			ytPlayer.playVideo();
			ytPlayer.mute();
		}
	}
	/**
	 * [onYouTubeIframeAPIReady YoutubeAPI読み込み時の処理をwebpack用にglonal objectに]
	 */
	window.onYouTubeIframeAPIReady = function() {
		if(r.state()()){
			ytPlayer = new YT.Player(
				'youtube_bg', // 埋め込む場所をIDで設定
				{
					videoId: videoID, // YouTubeのIDを指定
					width: 640,
					height: 400,
					playerVars: {
						rel: 0,
						controls: 0,
						autoplay: 1,
						showinfo: 0,
						'html5': 1
					},
					events: {
						'onReady': onPlayerReady,
						'onStateChange': onPlayerStateChange
					}
				}
			);
		}
	}
	//video要素の取得
	var video = $('.js-yt_frame_wrapper').find('video');
	//状態保存
	var btn_status = 0;

	//画面クリックで再生・ポーズ
	$('.js-yt_frame_wrapper').on('click', function () {
		if(video[0].paused){
			video[0].play();
		}else{
			video[0].pause();
		}
	});


	const videoControl = (action) => {
		let $playerWindow = $('iframe.youtube_bg.sp')[0].contentWindow;
		$playerWindow.postMessage('{"event":"command","func":"'+action+'","args":""}', '*');
	}
	$('.youtube_cover.sp .btn').on('click',function(ev){
		if($('body').hasClass('device--mobile--android')){
			$('iframe.youtube_bg.sp').css({
				'opacity':1,
				'z-index':2
			});
		}
		videoControl("playVideo");
	});
}



// WEBPACK FOOTER //
// ./dev/js/scripts/youtube_bg.js